import React from "react";

export default function Experience() {
  return (
    <div className="shadow-lg p-3 mb-5 bg-body-tertiary rounded">
      <h2 className="mt-5 text-center">Experience 🗽</h2>
      <hr className="w-25 mx-auto" />
      <div className="card text-center w-50 mx-auto ">
        <div className="card-header">Web Developer Intern</div>
        <div className="card-body">
          <h5 className="card-title">CodeClause</h5>
          <hr className="w-25 mx-auto" />
          <p className="card-text">
            Developed a portfolio website using HTML, CSS, and JavaScript to
            showcase projects, skills, and achievements..
          </p>
          <p className="card-text">
            Created a dynamic to-do list application with HTML, CSS, and
            JavaScript for efficient task management
          </p>
        </div>
      </div>

      <div className="card text-center w-50 mx-auto">
        <div className="card-header">Web Intern</div>
        <div className="card-body">
          <h5 className="card-title">LetGrow More</h5>
          <hr className="w-25 mx-auto" />
          <p className="card-text">
            Developed a calculator application using HTML, CSS, and JavaScript,
            providing basic arithmetic operations and a user-friendly interface.
          </p>
          <p className="card-text">
            Successfully delivered projects within deadlines, demonstrating
            strong project management skills and the ability to prioritize tasks
            effectively.
          </p>
        </div>
      </div>

      <div className="card text-center w-50 mx-auto">
        <div className="card-header">Summer Trainee</div>
        <div className="card-body">
          <h5 className="card-title">Techpile Technology Private Ltd</h5>
          <hr className="w-50 mx-auto" />
          <p className="card-text">
            Android With Java: Developed a ConvoChat application with messaging
            functionality, story feature, and profile management capabilities.
            Implemented real-time messaging for text.
          </p>
          <p className="card-text">
            Front-End Development: HTML, CSS, JS is used to design Front-end and
            using Bootstrap Framework to make responsive interface
          </p>
        </div>
      </div>

    </div>
  );
}
